import { NgModule } from '@angular/core';
import { CommaSeparatedPipe } from './pipes/comma-separated,pipe';
import { DecimalAsyncPipe } from './pipes/decimal.async.pipe';
import { DecimalPipe } from './pipes/decimal.pipe';
import { EnumArrayPipe } from './pipes/enum-array.pipe';
import { FormArraySortDescendPipe } from './pipes/form-array-sort-descend.pipe';
import { FormArraySortPipe } from './pipes/form-array-sort.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { HighlightSearch } from './pipes/highlight-search.pipe';
import { LessThanPipe } from './pipes/less-than.pipe';
import { MegabyteConversionPipe } from './pipes/megabyte.conversion.pipe';
import { MonthPipe } from './pipes/month.pipe';
import { NegativeToBlankPipe } from './pipes/negative-to-blank.pipe';
import { NotApplicablePipe } from './pipes/not-applicable.pipe';
import { OrderPipe } from './pipes/order.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { ZeroToBlankPipe } from './pipes/zero-to-blank.pipe';
import { ZeroToNullPipe } from './pipes/zero-to-null.pipe';
import { ZeroToTextPipe } from './pipes/zero-to-text.pipe';

const pipes = [
  TranslatePipe,
  ZeroToNullPipe,
  ZeroToBlankPipe,
  ZeroToTextPipe,
  DecimalPipe,
  DecimalAsyncPipe,
  CommaSeparatedPipe,
  HighlightSearch,
  MegabyteConversionPipe,
  NotApplicablePipe,
  OrderPipe,
  FormArraySortPipe,
  FormArraySortDescendPipe,
  EnumArrayPipe,
  MonthPipe,
  FormatDatePipe,
  NegativeToBlankPipe,
  LessThanPipe
];

@NgModule({
  declarations: pipes,
  exports: pipes,
  providers: [
    CommaSeparatedPipe,
    MegabyteConversionPipe
  ]
})
export class PipesModule { }
